export default __webpack_public_path__ + "static/media/psicocdmx2026.0410f171.pdf";